import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";

const NotificationRoute = ({ children }) => {
    const { role } = useSelector((state) => state);
    return children;
};

export default NotificationRoute;
